import { RefreshCw } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgRefresh = mkIcon(RefreshCw);